"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Popover = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const modal_manager_1 = require("@kawaui/modal-manager");
const portal_1 = __importDefault(require("@kawaui/portal"));
const react_1 = require("react");
const react_popper_1 = require("react-popper");
const react_transition_group_1 = require("react-transition-group");
const hooks_1 = require("./hooks");
const styled_1 = require("./styled");
const arrow_1 = require("./styled/arrow");
const types_1 = require("./types");
exports.Popover = (0, react_1.forwardRef)((props, forwardedRef) => {
    const { placement: suggestedPlacement, variant, title, content: contentBase, offset = 0, enableHover, fixed, lockPageScroll = false, disableArrow, arrowColors, disableClick, disableOffset, disablePortal, open: controlledOpen, hideOtherContent, children } = props, otherProps = __rest(props, ["placement", "variant", "title", "content", "offset", "enableHover", "fixed", "lockPageScroll", "disableArrow", "arrowColors", "disableClick", "disableOffset", "disablePortal", "open", "hideOtherContent", "children"]);
    const content = contentBase || title;
    const { open: uncontrolledOpen, handleOpen, handleClose, toggleOpen } = (0, hooks_1.useOpen)();
    const isControlled = typeof controlledOpen !== 'undefined';
    const open = (isControlled && controlledOpen) || uncontrolledOpen;
    const { ref: managerRef, onDone, container } = (0, modal_manager_1.useManager)({ open, lockPageScroll });
    const [reference, setReference] = (0, react_1.useState)(null);
    const [popper, setPopper] = (0, react_1.useState)(null);
    const [arrow, setArrow] = (0, react_1.useState)(null);
    const [arrowColor, setArrowColor] = (0, react_1.useState)(null);
    const config = {
        modifiers: [],
        placement: suggestedPlacement,
    };
    if (!disableArrow)
        config.modifiers.push({ name: 'arrow', options: { element: arrow } });
    if (!disableOffset)
        config.modifiers.push({ name: 'offset', options: { offset: [0, arrow_1.ARROW_SIZE + offset] } });
    if (fixed)
        config.strategy = 'fixed';
    const { styles, attributes, state } = (0, react_popper_1.usePopper)(reference, popper, config);
    const placement = state && state.placement;
    (0, react_1.useEffect)(() => {
        switch (placement) {
            case types_1.PositionPlacement.BOTTOM_START:
            case types_1.PositionPlacement.BOTTOM:
            case types_1.PositionPlacement.BOTTOM_END:
                if (arrowColors && arrowColors.top)
                    setArrowColor(arrowColors.top);
                break;
            case types_1.PositionPlacement.TOP_START:
            case types_1.PositionPlacement.TOP:
            case types_1.PositionPlacement.TOP_END:
                if (arrowColors && arrowColors.bottom)
                    setArrowColor(arrowColors.bottom);
                break;
            case types_1.PositionPlacement.RIGHT_START:
            case types_1.PositionPlacement.RIGHT:
            case types_1.PositionPlacement.RIGHT_END:
                if (arrowColors && arrowColors.left)
                    setArrowColor(arrowColors.left);
                break;
            case types_1.PositionPlacement.LEFT_START:
            case types_1.PositionPlacement.LEFT:
            case types_1.PositionPlacement.LEFT_END:
                if (arrowColors && arrowColors.right)
                    setArrowColor(arrowColors.right);
                break;
            default:
                break;
        }
    }, [placement, arrowColors]);
    (0, react_1.useEffect)(() => {
        if (hideOtherContent)
            onDone();
    }, [open]);
    const eventHandlers = {};
    if (!disableClick) {
        eventHandlers.onClick = toggleOpen;
        eventHandlers.onMouseLeave = handleClose;
    }
    if (enableHover)
        eventHandlers.onMouseEnter = handleOpen;
    const child = react_1.Children.only(children);
    const triggerProps = Object.assign(Object.assign({}, eventHandlers), { ref: setReference });
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, react_1.isValidElement)(child) && (0, react_1.cloneElement)(child, triggerProps), (0, jsx_runtime_1.jsx)(portal_1.default, { container, disablePortal, children: (0, jsx_runtime_1.jsx)(react_transition_group_1.CSSTransition, { mountOnEnter: true, unmountOnExit: true, appear: true, in: open, timeout: styled_1.ANIMATION_DURATION, children: (0, jsx_runtime_1.jsx)(styled_1.StyledWrapper, Object.assign({}, otherProps, { children: (0, jsx_runtime_1.jsxs)(styled_1.Container, Object.assign({ variant: variant, ref: (ref) => {
                                setPopper(ref);
                                managerRef.current = ref;
                                return forwardedRef;
                            }, style: styles.popper }, attributes.popper, { children: [contentBase && title && (0, jsx_runtime_1.jsx)(styled_1.Title, { children: title }), content && (0, jsx_runtime_1.jsx)(styled_1.Content, { children: content }), !disableArrow && ((0, jsx_runtime_1.jsx)(styled_1.Arrow, { ref: setArrow, style: styles.arrow, variant: variant, placement: placement, customColor: arrowColor }))] })) })) }) })] }));
});
exports.Popover.displayName = 'Popover';
exports.default = exports.Popover;
